cv.mixins.SyncModel = {
  // Mapping for updates and patches
  saveMap : {},

  // Map for any changed attributes
  changeMap : {},

  initialize: function() {
    this.changeMap = {};

    if(!_.isUndefined(arguments[1])){
      if(_.has(arguments[1], 'synced')){
        this.synced = arguments[1].synced;
      }
    }else{
      this.synced = false;
    }

    // Any model changes we want to make sync false
    this.on('change', function(model, xhr){
      console.log('Model change: ', model.changedAttributes());

      if(model.changedAttributes() != false){
        // Merge into the change map
        _.extend(this.changeMap, model.changedAttributes());
        this.synced = false;

        console.log('Change map: ', this.changeMap);
      }

      console.log('Model sync status: ' + this.synced);
      console.groupEnd();
    }, this);

    // Request method
    this.on('request', function(model, xhr){
      console.groupCollapsed('Fetching model...');
      console.log('Requesting ' + model.get('id') + '... ');
    }, this);

    // Set the synced flag to true
    this.on('sync', function(model, xhr){
      this.synced = true;
      this.changeMap = {};

      console.log('Model sync status: ' + this.synced);
    }, this);
  },

  parseSaveMap: function(attrs, map, is_nested){
    var attrs = _.isUndefined(attrs) ? {} : attrs;
    var data = {};
    var is_nested = _.isUndefined(is_nested) ? false : true;

    _.each(map, function(value, key, list){
      if(_.isObject(map[key])){
        data[key] = this.parseSaveMap(attrs, map[key], true);
      }else{
        // If we pass in an empty attributes, then we are saving the model without passing attributes
        // Merge it with the changeMap
        if(_.isEmpty(attrs)){
          attrs = _.extend(attrs, this.changeMap);
        }

        // Special logic for custom values
        if(key == 'custom_values'){
          data['custom_values'] = this.get('custom_values');
        }

        // If this is a nested attribute then we want to parse all values
        if(_.has(attrs, value) || is_nested == true){
          data[key] = this.get(value);
        }
      }
    }, this);

    // Remove any empty data objects
    if(!_.isEmpty(data)){
      return data;
    }
  },

  isSynced: function(){
    return this.synced;
  }
};
